import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';

const CampaignListDetails = () => {
  const navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_DOMAIN}marketing/campaigns/`, { headers, params: { page_size: 500 } })
      .then(res => {
        const data = res.data?.data ?? res.data;
        const list = Array.isArray(data) ? data : (data?.results || []);
        setCampaigns(list);
      })
      .catch(err => console.error('Error fetching campaigns:', err))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Type', value: 'campaign_type' },
    { label: 'Status', value: 'status' },
    { label: 'Recipients', value: 'total_recipients' },
    { label: 'Sent', value: 'sent_count' },
    { label: 'Opened', value: 'opened_count' },
    {
      label: 'Recipients',
      value: (item) => (
        <button className="btn btn-ghost btn-sm" onClick={() => navigate(`/marketing/campaign/${item.id}/recipients`)}>
          View Recipients
        </button>
      ),
    },
  ];

  return (
    <div>
      <ListTemplate columns={columns} data={campaigns} loading={loading} title="Marketing Campaigns" />
    </div>
  );
};

export default CampaignListDetails;
